<auth-layout [title]="signupTitle"
             type="SIGNUP"
             subTitile="Complete your business profile to get started."
             [isHiddenImage]="true"
             [hideHeader]="true">
  <div class="login-page">
    <div class="login-card">
      <div class="login-header">
        <h2>Business Details</h2>
        <p class="subtitle">Complete your business profile to get started.</p>
      </div>

      <form [formGroup]="businessform" class="login-form">
        <div class="form-group">
          <div class="d-flex justify-content-between">
            <div class="w-48">
              <label for="fName" class="for-label">First Name<span class="yy">*</span></label>
              <input id="fName"
                     type="text"
                     class="form-control mt-2"
                     formControlName="fName"
                     maxlength="50"
                     (keypress)="preventSpace($event)"
                     placeholder="Enter First Name">
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('fName')?.hasError('required') && isSubmitted">
                  Please enter first name.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('fName')?.hasError('minlength') && businessform.get('fName')?.dirty">
                  *Please enter minimum 2 characters.
                </div>
              </div>
            </div>

            <div class="w-48">
              <label for="lName" class="for-label">Last Name<span class="yy">*</span></label>
              <input id="lName"
                     type="text"
                     class="form-control mt-2"
                     formControlName="lName"
                     maxlength="50"
                     (keypress)="preventSpace($event)"
                     placeholder="Enter Last Name">
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('lName')?.hasError('required') && isSubmitted">
                  Please enter last name.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('lName')?.hasError('minlength') && businessform.get('lName')?.dirty">
                  *Please enter minimum 2 characters.
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="w-48">
              <label for="email" class="for-label">Email Address<span class="yy">*</span></label>
              <input id="email"
                     type="text"
                     class="form-control mt-2"
                     formControlName="email"
                     maxlength="250"
                     (keypress)="preventSpace($event)"
                     placeholder="Enter Email Address">
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('email')?.hasError('required') && isSubmitted">
                  *Email is required.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('email')?.hasError('pattern') && businessform.get('email')?.dirty">
                  *Please enter a valid email.
                </div>
              </div>
            </div>
          </div>

          <p class="owner mt-3">Business Details</p>

          <div class="d-flex justify-content-between">
            <div class="w-48">
              <label for="company" class="for-label">Company Name<span class="yy">*</span></label>
              <input id="company"
                     type="text"
                     class="form-control mt-2"
                     formControlName="company"
                     (keypress)="allowCompanyName($event)"
                     maxlength="100"
                     placeholder="Enter Company Name">
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('company')?.hasError('required') && isSubmitted">
                  *Company name is required.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('company')?.hasError('minlength') && businessform.get('company')?.dirty">
                  *Company name must be at least 2 characters.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('company')?.hasError('maxlength') && businessform.get('company')?.dirty">
                  *Company name cannot exceed 100 characters.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('company')?.hasError('pattern') && businessform.get('company')?.dirty">
                  *Only letters, numbers, spaces, hyphens, and dots are allowed.
                </div>
              </div>
            </div>

            <div class="w-50">
              <label for="businessRegNumber" class="for-label">Business Registration Number<span class="yy">*</span></label>
              <input id="businessRegNumber"
                     type="text"
                     class="form-control mt-2"
                     formControlName="businessRegNumber"
                     maxlength="30"
                     (keypress)="allowAlphanumericOnly($event)"
                     placeholder="Enter Business Registration Number">
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('businessRegNumber')?.hasError('required') && isSubmitted">
                  *Registration number is required.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('businessRegNumber')?.hasError('minlength') && businessform.get('businessRegNumber')?.dirty">
                  *Registration number must be at least 5 characters.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('businessRegNumber')?.hasError('maxlength') && businessform.get('businessRegNumber')?.dirty">
                  *Registration number cannot exceed 30 characters.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('businessRegNumber')?.hasError('pattern') && businessform.get('businessRegNumber')?.dirty">
                  *Only alphanumeric characters are allowed.
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="w-48">
              <label for="monthlyRevenue" class="for-label">Monthly Revenue<span class="yy">*</span></label>
              <select id="monthlyRevenue"
                      class="form-control mt-2"
                      formControlName="monthlyRevenue">
                <option value="">Select Monthly Revenue</option>
                <option value="Less than R20k">Less than R20k</option>
                <option value="R20k to R50k monthly">R20k - R50k</option>
                <option value="R20k to R50k monthly">R20k - R50k</option>
                <option value="More than R500k monthly">More than R500k</option>
              </select>
            </div>

            <div class="w-50">
              <label for="url" class="for-label">Website's URL (Optional)</label>
              <input id="url"
                     type="text"
                     class="form-control mt-2"
                     formControlName="url"
                     (keypress)="preventSpace($event)"
                     placeholder="Enter the URL">
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('url')?.hasError('pattern') && businessform.get('url')?.dirty">
                  *Please enter a valid URL.
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="w-100">
              <div class="row">
                <p class="textt">Are you VAT registered?</p>
              </div>

              <div class="row">
                <div class="col p-0">
                  <div class="d-flex justify-content-start align-items-center mb-2">
                    <div class="form-check form-check-inline mr-3">
                      <input class="form-check-input"
                             type="radio"
                             name="vatRegistered"
                             value="true"
                             (click)="open()">
                      <label class="form-check-label">Yes</label>
                    </div>

                    <div class="form-check form-check-inline">
                      <input class="form-check-input"
                             type="radio"
                             name="vatRegistered"
                             value="false"
                             (click)="close()">
                      <label class="form-check-label">No</label>
                    </div>
                  </div>

                  <div class="hhh" *ngIf="showInput">
                    <input type="text"
                           class="form-control"
                           formControlName="vatNumberInput"
                           (keypress)="preventSpace($event)"
                           maxlength="15"
                           placeholder="Enter VAT Number">
                    <div class="for-validation mb-4">
                      <div class="for-validation text-danger"
                           *ngIf="businessform.get('vatNumberInput')?.hasError('required') && isSubmitted">
                        *VAT registered number is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p class="owner mt-3">Business Banking Details</p>

          <div class="d-flex justify-content-between">
            <div class="w-48">
              <label for="bankname" class="for-label">Bank Name<span class="yy">*</span></label>
              <input id="bankname"
                     type="text"
                     class="form-control mt-2"
                     formControlName="bankname"
                     (keypress)="allowAlphabetsAndSpaces($event)"
                     maxlength="60"
                     placeholder="Enter Bank Name">
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('bankname')?.hasError('required') && isSubmitted">
                  *Please enter bank name.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('bankname')?.hasError('minlength') && businessform.get('bankname')?.dirty">
                  *Bank name must be at least 2 characters.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('bankname')?.hasError('maxlength') && businessform.get('bankname')?.dirty">
                  *Bank name cannot exceed 60 characters.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('bankname')?.hasError('pattern') && businessform.get('bankname')?.dirty">
                  *Only alphabets and spaces are allowed.
                </div>
              </div>
            </div>

            <div class="w-50">
              <label for="branchname" class="for-label">Branch Name<span class="yy">*</span></label>
              <input id="branchname"
                     type="text"
                     class="form-control mt-2"
                     formControlName="branchname"
                     (keypress)="allowAlphanumericAndSpaces($event)"
                     maxlength="80"
                     placeholder="Enter Branch Name">
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('branchname')?.hasError('required') && isSubmitted">
                  *Branch name is required.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('branchname')?.hasError('minlength') && businessform.get('branchname')?.dirty">
                  *Branch name must be at least 2 characters.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('branchname')?.hasError('maxlength') && businessform.get('branchname')?.dirty">
                  *Branch name cannot exceed 80 characters.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('branchname')?.hasError('pattern') && businessform.get('branchname')?.dirty">
                  *Only letters, numbers, and spaces are allowed.
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="w-48">
              <label for="swiftcode" class="for-label">SWIFT Code<span class="yy">*</span></label>
              <input id="swiftcode"
                     type="text"
                     class="form-control mt-2"
                     formControlName="swiftcode"
                     maxlength="11"
                     (keypress)="preventSpace($event)"
                     (input)="toUpperCase($event)"
                     placeholder="Enter SWIFT Code">
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('swiftcode')?.hasError('required') && isSubmitted">
                  *SWIFT code is required.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('swiftcode')?.hasError('pattern') && businessform.get('swiftcode')?.dirty">
                  *SWIFT code must be 8 or 11 uppercase alphanumeric characters.
                </div>
              </div>
            </div>

            <div class="w-50">
              <label for="accountType" class="for-label">Account Type<span class="yy">*</span></label>
              <select id="accountType"
                      class="form-control mt-2"
                      formControlName="accountType">
                <option value="">Account type</option>
                <option value="Savings Account">Savings Account</option>
                <option value="Current Account">Current Account</option>
                <option value="Business Account">Business Account</option>
                <option value="Cheque Account">Cheque Account</option>
                <option value="Transmission Account">Transmission Account</option>
              </select>
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('accountType')?.hasError('required') && isSubmitted">
                  *Enter your account type.
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="w-48">
              <label for="accountName" class="for-label">Account Name<span class="yy">*</span></label>
              <input id="accountName"
                     type="text"
                     class="form-control mt-2"
                     formControlName="accountName"
                     (keypress)="allowAlphanumericAndSpaces($event)"
                     maxlength="100"
                     placeholder="Enter Account Name">
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('accountName')?.hasError('required') && isSubmitted">
                  *Enter your account name.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('accountName')?.hasError('minlength') && businessform.get('accountName')?.dirty">
                  *Account name must be at least 2 characters.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('accountName')?.hasError('maxlength') && businessform.get('accountName')?.dirty">
                  *Account name cannot exceed 100 characters.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('accountName')?.hasError('pattern') && businessform.get('accountName')?.dirty">
                  *Only letters, numbers, and spaces are allowed.
                </div>
              </div>
            </div>

            <div class="w-50">
              <label for="accountNumber" class="for-label">Account Number<span class="yy">*</span></label>
              <input id="accountNumber"
                     type="text"
                     class="form-control mt-2"
                     formControlName="accountNumber"
                     maxlength="17"
                     (keypress)="NumOnly($event)"
                     placeholder="Enter Account Number">
              <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('accountNumber')?.hasError('required') && isSubmitted">
                  *Account number is required.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('accountNumber')?.hasError('pattern') && businessform.get('accountNumber')?.dirty">
                  *Account number must contain only digits.
                </div>
                <div class="for-validation text-danger"
                     *ngIf="businessform.get('accountNumber')?.hasError('minlength') && businessform.get('accountNumber')?.dirty">
                  *Account number must be at least 5 digits.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" style="margin-top: 10px;">
          <div class="d-flex justify-content-center">
            <button type="button"
                    class="btn btny for-login"
                    (click)="businessDetaile()">
              SUBMIT
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</auth-layout>